<template>
  <v-card class="full-height">
    <v-card-text>
      <h3 class="title font-weight-regular">Visitors Map</h3>
      <h6 class="subtitle-2 font-weight-light">
        Visitor statistics by country
      </h6>
      <div
        v-if="isLoading"
        class="d-flex justify-center align-center"
        style="height:400px"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="!isLoading">
        <MapChart
          :countryData="data"
          highColor="#ff3300"
          lowColor="#aaaaaa"
          countryStrokeColor="#909090"
          defaultCountryFillColor="#f2f2f2"
          LangUser="kr"
          class="map-chart"
        />
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import MapChart from "vue-map-chart";

export default {
  name: "TheVisitCountryMap",
  props: ["countryData"],
  components: {
    MapChart
  },
  data: () => ({
    isLoading: false,
    data: {}
  }),
  async mounted() {
    this.isLoading = true;
    let iter = 0;
    console.log(!this.countryData);
    while (!this.countryData) {
      iter++;
      console.log(iter);
      await this.sleep(100);
      if (iter > 100) break;
    }
    this.data = this.countryData;
    this.isLoading = false;
  },
  watch: {
    countryData: async function(newVal) {
      this.isLoading = true;
      await this.sleep(1500);
      this.data = newVal;
      this.isLoading = false;
    }
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  .full-height {
    height: 100%;
  }
}
.map-chart {
  z-index: 1;
}
</style>
